import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref, watch } from 'vue';
import { AppType, ConfigItemType } from '@/views/applications/types';
import { APP_BASE_INFO, SUB_KEYS, CONFIG_TYPES } from '@/views/applications/constance';
import { Delete, Edit } from '@element-plus/icons-vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import ApplicationService from '@/services/applicationService';
import AddConfig from '@/views/applications/pop/addConfig.vue';
import EditConfig from '@/views/applications/pop/editConfig.vue';
import EditBaseInfo from '@/views/applications/pop/editBaseInfo.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationDetail',
  props: {
  application: {
    type: Object as PropType<AppType>,
    default: () => { },
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;


const appInfo = ref<AppType>({} as AppType);
const addVisible = ref(false);
const editVisible = ref(false);
const editTitle = ref('');
const editKey = ref('');
const editData = ref();
const baseVisible = ref(false);


watch(
  () => props.application,
  (newVal) => {
    appInfo.value = newVal;
  },
  { deep: true, immediate: true }
);

//pushPlateform 0-Android 1-IOS
//configType 0-普通推送 1-VOIP推送

//计算属性，用于存储需要显示的配置信息及其标题
const configs = computed(() => {
  const result: { [key: string]: ConfigItemType[] } = {};
  for (const key of CONFIG_TYPES.keys()) {
    let config: ConfigItemType[] = (appInfo.value as any)[key];
    if (config && config.length) {
      config.forEach((item) => {
        if (item.configType <= 1 && item.pushPlateform === 0) {
          delete item.iosSound; // 仅在Android平台移除iOS属性
          return item;
        }
      });
      result[key] = config;
    }
  }
  return result;
});


const showVoipItem = (configType: number, pushPlatform: number) => {
  if (appInfo.value.hasVOIP) {
    return true;
  } else {
    return !((configType === 1 && pushPlatform === 1) || (configType === 1 && pushPlatform === 0));
  }
};


const judgePushType = (title: string, configType: number, pushPlatform: number) => {
  if (title === '华为HMS推送配置') return '普通推送';
  if (title === '小米推送配置') return '普通推送';
  if (title === 'OPPO推送配置') return '普通推送';
  if (title === 'VIVO推送配置') return '普通推送';
  if (configType === 0 && pushPlatform === 1) {
    return 'IOS普通推送';
  }
  if (configType === 1 && pushPlatform === 1) {
    return 'IOS VOIP推送';
  }
  if (configType === 0 && pushPlatform === 0) {
    return 'Android普通推送';
  }
  if (configType === 1 && pushPlatform === 0) {
    return 'Android VOIP推送';
  }
};



//确认添加事件
const handleConfirm = async (value: any, config: string) => {

  if (Array.isArray(value)) {
    appInfo.value.callbackUrls = value;
  } else {
    if (config === 'oneSignalConfig') {
      if (!appInfo.value.oneSignalConfig) appInfo.value.oneSignalConfig = [];
      appInfo.value.oneSignalConfig.push(value);
    } else if (config === 'jConfig') {
      if (!appInfo.value.jConfig) appInfo.value.jConfig = [];
      appInfo.value.jConfig.push(value);
    } else if (config === 'hmsConfig') {
      if (!appInfo.value.hmsConfig) appInfo.value.hmsConfig = [];
      appInfo.value.hmsConfig.push(value);
    } else if (config === 'miConfig') {
      if (!appInfo.value.miConfig) appInfo.value.miConfig = [];
      appInfo.value.miConfig.push(value);
    } else if (config === 'oppoConfig') {
      if (!appInfo.value.oppoConfig) appInfo.value.oppoConfig = [];
      appInfo.value.oppoConfig.push(value);
    } else if (config === 'vivoConfig') {
      if (!appInfo.value.vivoConfig) appInfo.value.vivoConfig = [];
      appInfo.value.vivoConfig.push(value);
    }
  }
  await updateConfig();
};


//删除事件
const handleDelete = (configList: ConfigItemType[], configKey: string, index?: number) => {
  ElMessageBox.confirm('是否删除该配置？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(async () => {
    if (index === undefined) {
      appInfo.value.callbackUrls = [];
    } else {
      const clickedConfig = configList[index];
      if (configKey) {
        const internalConfig = appInfo.value[configKey as keyof AppType] as ConfigItemType[];
        const targetIndex = internalConfig.findIndex((item) => item.configType === clickedConfig.configType && item.pushPlateform === clickedConfig.pushPlateform && item.bundleId == clickedConfig.bundleId);
        if (targetIndex !== -1) {
          internalConfig.splice(targetIndex, 1);
        }
      }
    }
    await updateConfig();
  });
};


//编辑事件
const handleEdit = (configList: ConfigItemType[], configKey: string, index?: number) => {
  editVisible.value = true;
  editTitle.value = CONFIG_TYPES.get(configKey as string) || '';
  editKey.value = configKey;
  editData.value = index === undefined ? configList : configList[index];
};


//编辑保存
const handleSaveEdit = async (value: any, config: string, oldBundleId?: string) => {

  let configKey = '';
  if (config === 'OneSignal配置') configKey = 'oneSignalConfig';
  else if (config === '极光推送配置') configKey = 'jConfig';
  else if (config === '华为HMS推送配置') configKey = 'hmsConfig';
  else if (config === '小米推送配置') configKey = 'miConfig';
  else if (config === 'OPPO推送配置') configKey = 'oppoConfig';
  else if (config === 'VIVO推送配置') configKey = 'vivoConfig';

  if (configKey && Array.isArray((appInfo.value as any)[configKey])) {
    const arr = (appInfo.value as any)[configKey];
    const idx = arr.findIndex((item:any) =>
      item.configType === value.configType &&
      item.pushPlateform === value.pushPlateform &&
      item.bundleId === oldBundleId 
    );
    if (idx !== -1) {
      arr[idx] = { ...arr[idx], ...value };
    }
  }
  await updateConfig();
  editVisible.value = false;
};


const handleSaveBaseInfo = async (value: any) => {
  appInfo.value.appName = value.appName;
  appInfo.value.appDescription = value.appDescription;
  appInfo.value.hasVOIP = value.hasVOIP;

  await updateConfig();
};


const updateConfig = async () => {
  try {
    // 尝试更新应用配置
    const res = await ApplicationService.update(appInfo.value, appInfo.value.appId);
    if (res.code === 1) {
      ElMessage({
        type: 'success',
        message: '操作成功',
      });
    }
  } catch (error:any) {
    // 捕获并处理任何可能的错误
    ElMessage({
      type: 'error',
      message: `删除配置时发生错误: ${error.message || '未知错误'}`,
    });
  }
};

const __returned__ = { props, appInfo, addVisible, editVisible, editTitle, editKey, editData, baseVisible, configs, showVoipItem, judgePushType, handleConfirm, handleDelete, handleEdit, handleSaveEdit, handleSaveBaseInfo, updateConfig, get APP_BASE_INFO() { return APP_BASE_INFO }, get SUB_KEYS() { return SUB_KEYS }, get CONFIG_TYPES() { return CONFIG_TYPES }, get Delete() { return Delete }, get Edit() { return Edit }, AddConfig, EditConfig, EditBaseInfo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})